exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".realname-table {\n  flex: auto;\n  overflow: auto;\n}\n", ""]);
